import { Button, Form, Input, Modal } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import "./EditSpeakerModal.css";
import { speakerStyles } from "../../../../utils/speakerStyle";
import TooltipButton from "../../../Template/Buttons/TooltipButton";
import { useForm } from "antd/es/form/Form";
import { useAppDispatch } from "../../../../redux/useAppDispatch";
import { updateSpeaker } from "../../../../redux/JobModule/QCDetailPage/QCDetailPageAction";
import { TranscriptionBlockType } from "../../../../utils/type";
interface EditSpeakerModalProps {
  close: () => void;
  openState: boolean;
  open: () => void;
}
function EditSpeakerModal(props: EditSpeakerModalProps) {
  //Modal Close Reseting the Fields
  const handleModalClose = () => {
    props.close();
  };
  const [form] = useForm();
  const dispatch = useAppDispatch();
  //here is my speaker "['speaker_0']", so please help me to get the speaker name, please preprocess it by convert this string to array
  const idTranscription = useSelector((state: RootState) => state.qCDetailPageState.data.transcriptions[0].idTranscription);
  const [newSpeakerCount, setNewSpeakerCount] = useState(0);
  const [error, setError] = useState<string>("");
  const updateSpeakerLoading = useSelector((state: RootState) => state.qCDetailPageState.updateSpeakerLoading);
  const transcription = useSelector((state: RootState) => state.qCDetailPageState.data.transcriptions[0]);
  const apiSpeakers = transcription.speakers;

  const [speakers, setSpeakers] = useState<{ value: string; existed: boolean; name: string }[]>([]);

  useEffect(() => {
    const uniqueSpeakers = [] as any[];
    const usedSpeaker = transcription.transcriptionBlocks.map((block: TranscriptionBlockType) => block?.speaker);
    apiSpeakers.forEach((speaker: string) => {
      if (usedSpeaker.includes(speaker)) {
        uniqueSpeakers.push({
          name: speaker,
          value: speaker,
          existed: true,
        });
      } else {
        uniqueSpeakers.push({
          name: speaker,
          value: speaker,
          existed: false,
        });
      }
    });
    setSpeakers(uniqueSpeakers);
    return () => {
      setError("");
      form.resetFields();
      setSpeakers([]);
    };
  }, [props.openState]);

  const EditSpeakerModalContent = () => {
    const saveSpeaker = async (values: any) => {
      const payload = {
        TranscriptionId: idTranscription,
        Speakers: values,
      };
      let emptySpeaker = false;
      //check if any property in values object is empty
      Object.keys(values).forEach((key) => {
        if (values[key] === "") {
          emptySpeaker = true;
        }
      });
      if (emptySpeaker) {
        return setError("Speakers invalid (duplicate speakers or speaker name is blank)");
      }
      try {
        await dispatch(updateSpeaker({ id: idTranscription, data: payload })).unwrap();
        handleModalClose();
      } catch (error: any) {
        const errorMsg = error.response.data.detailedMessages[0];
        setError(errorMsg ? errorMsg : "An error occurred while updating the speakers. Please try again.");
      }
    };
    return (
      <div className="d-flex flex-column gap-4 w-100 modal-body-content ">
        <h4> Edit Speakers</h4>
        <p>Changing the speakers will update all the segments that have been assigned to them.</p>
        <Form
          onFinish={saveSpeaker}
          className="d-flex flex-column gap-3 overflow-y-auto"
          form={form}>
          {speakers.map((speaker: any, index: number) => (
            <div
              className="d-flex gap-3"
              key={index}>
              <div className="speaker-name">
                <div
                  className="edit-speaker-color position-absolute"
                  style={{ backgroundColor: `${speakerStyles[index].color}` }}
                />
                <Form.Item
                  name={speaker.name}
                  initialValue={speaker.value}
                  key={index}>
                  <input placeholder="Untitled Speaker" />
                </Form.Item>

                {!speaker.existed && (
                  <TooltipButton
                    iconName="delete"
                    type="secondary"
                    text="Delete Speaker"
                    onClick={() => {
                      const newSpeakers = speakers.filter((_, i) => i !== index);
                      setSpeakers(newSpeakers);
                    }}
                  />
                )}
              </div>
            </div>
          ))}
        </Form>

        <div className="d-flex justify-content-end">
          <TooltipButton
            iconName="add"
            type="secondary"
            text="Add new Speaker"
            onClick={() => {
              setSpeakers((prev) => [...prev, { value: "", existed: false, name: `__NEW__${newSpeakerCount}` }]);
              setNewSpeakerCount((prev) => prev + 1);
            }}
          />
        </div>
        {error && <div className="error justify-content-end align-self-end mb-2">{error}</div>}

        <div className="d-flex gap-3 justify-content-end">
          <Button
            typeof="submit"
            type="primary"
            loading={updateSpeakerLoading}
            onClick={() => form.submit()}>
            Save
          </Button>

          <Button
            className="cancelButton"
            htmlType="reset"
            loading={updateSpeakerLoading}
            onClick={handleModalClose}>
            Cancel
          </Button>
        </div>
      </div>
    );
  };
  return (
    <div>
      <Modal
        centered
        zIndex={1500}
        footer={[]}
        width={400}
        onCancel={handleModalClose}
        open={props.openState}>
        <EditSpeakerModalContent />
      </Modal>
    </div>
  );
}

export default EditSpeakerModal;
